import React from 'react';

import classNames from 'classnames';

const BlockCover = ({ backgroundUrl, title, subtitle, repeatedTitle = false, children }) => (
  <div className={classNames(
    'block-cover-container',
    {
      'block-cover-container-repeated': repeatedTitle
    }
  )} style={{
    backgroundImage: `url(${backgroundUrl})`
  }}>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1 className="block-cover-header">
            <span className="block-cover-header-title caveat">{title}</span>
            {subtitle ? (
              <span className="block-cover-header-subtitle"><br />{subtitle}</span>
            ): null}
          </h1>
          {children ? (
            <div className="block-cover-content">
              {children}
            </div>
          ) : null}

          {repeatedTitle ? <p className="block-cover-repeated-title">{title}</p> : null}
        </div>
      </div>
    </div>
  </div>
)

export default BlockCover;



// WEBPACK FOOTER //
// ./src/components/block-cover.js